var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      attrs: {
        name: "addteammodal",
        width: "70%",
        minHeight: 300,
        minWidth: 200,
        maxWidth: 800,
        scrollable: true,
        adaptive: true,
        reset: true,
        height: "auto"
      }
    },
    [
      _c("div", { staticClass: "modal--container" }, [
        _c("div", { staticClass: "d-flex justify-content-between pt-3" }, [
          _c("h4", [_vm._v("Add New Team")]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "close",
              attrs: { type: "button" },
              on: { click: _vm.closeModal }
            },
            [
              _c(
                "span",
                { attrs: { "aria-hidden": "true" } },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: "times", size: "1x" }
                  })
                ],
                1
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex flex-column h-100" }, [
          _c("div", { staticClass: "row mt-4" }, [
            _c(
              "div",
              { staticClass: "col-12 col-md-5 form-group edit-modal-item" },
              [
                _c("span", { staticClass: "cus-label" }, [_vm._v("Team name")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.teamName,
                      expression: "teamName"
                    }
                  ],
                  attrs: { type: "text", placeholder: "", required: "" },
                  domProps: { value: _vm.teamName },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.teamName = $event.target.value
                    }
                  }
                })
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "row justify-content-end align-items-end button-container"
            },
            [
              _c(
                "button",
                {
                  staticClass: "save_btn hover-dark",
                  attrs: { type: "submit" },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.addTeam.apply(null, arguments)
                    }
                  }
                },
                [_vm._v("\n          Add Team\n        ")]
              )
            ]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1d537874", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d537874","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OfficeAdmin/Teams/AddTeamModal.vue
// module id = null
// module chunks = 